export default "__VITE_ASSET__DQt7qv7M__"